import { IpTrafficParamTable, Oid, OntParams, RowStatus, ServicePort, ServicePortList, srvPortParaType, srvPortType } from "@ip6m/types";
import { HttpException, Injectable, Logger, NotFoundException, OnApplicationBootstrap } from "@nestjs/common";
import { OidDefinition } from "../interfaces/oid";
import { HuaweiOidDB } from "./huawei_oid.service";
import { OidDB } from "./oid.service";
import { OltDB } from "./olt_database.service";
import { SnmpService } from "./snmp.service";

const snmp = require("net-snmp");
@Injectable()
export class ServicePortService implements OnApplicationBootstrap {
    
    private ServicePorts: ServicePortList;
    private lastSrvPortId: number[] = [];   // indexed by OLT ID
    private IpTrafficParamTable: IpTrafficParamTable = {};
    private oids: OidDefinition;
    private numericOids: string[];

    constructor(
        private oltDb: OltDB,
        private oidDB: OidDB, 
        private huawei_oidDB: HuaweiOidDB,
        private snmpService: SnmpService) {
            this.oids = this.huawei_oidDB.SrvFlowTable();
            this.numericOids = this.oidDB.getChildrenOids(this.oids);    
        }

    onApplicationBootstrap() {
        const olts = this.oltDb.getOlts;
        olts.forEach((olt, index) =>{
            this.initServicePorts(index);
        })
    }


    calcKeysFromParas(spOids) {
        /* Description from the mib:

        Para1: If the value of ParaType is set to 2, 4, 6, 9, 10, 11, 12, 13, 14 or 15, 
        this leaf indicates the shelf ID. (= frame ID)

        Para2: If the value of ParaType is set to 2, 4, 6, 9, 10, 11, 12, 13, 14 or 15, 
        this leaf indicates the slot ID.

        Para3: If the value of ParaType is set to 2, 4, 6, 9, 10, 11, 12, 13, 14 or 15, 
        this leaf indicates the port ID.

        Para4: If the value of ParaType is set to 4, this leaf indicates the ONT ID 
            for the GPON profile mode and GEM port ID for the GPON distributed mode.
            If the value of ParaType is set to 14, this leaf indicates the ONT ID and 
            the type of service-port endpoint. The upper 16 bits are the ONT ID!

        Para5: If the value of ParaType is set to 4, this leaf indicates the GEM port index for 
            the GPON profile mode and is reserved for the GPON distributed mode.
            If the value of hwExtSrvFlowParaType is set to 9, 10, 11, 12, this leaf indicates the port mask
            of ports on ONT, bit0 indicates port 1, bit1 indicates port 2, and so on, the max port number is 8, 
            only for ONT service flow.
            If the value of ParaType is set to 14, this leaf is valid only when the service-port 
            is configured on the ONT Ethernet port.
        
        And te 6th oid is the ParaType:
            pvc(1),
            eth(2),
            vdsl(3),
            gpon(4),  <--
            shdsl(5),
            epon(6),
            vcl(7),
            adsl(8),
            gponOntEth(9),  <--
            eponOntEth(10),
            gponOntIphost(11),  <--
            eponOntIphost(12),
            eocCnuEth(13),
            xponEndToEnd(14),  <--
            docsis(15)
        */

            const type = spOids['7'];
            const allowedTpyes = [4, 9, 11, 14];
            if(allowedTpyes.includes(type)) {
                let ontId: number;
                if(type == 14) {
                    ontId = Math.floor(spOids['5'] / 65536); // Upper 16 bits
                }
                else {
                    ontId = spOids['5'];
                }
                return {
                    frame: spOids['2'],
                    slot: spOids['3'],
                    port: spOids['4'],
                    ontId: ontId
                }
            } else {
                throw new HttpException ('Not allowed SrvPortParaType: ' + type, 500);
            }
        
    }

    addServicePort(oltid: number, ontParams: OntParams, srvPortParams: ServicePort) {
        console.log(this.lastSrvPortId);
        console.log(ontParams);
        console.log(srvPortParams);

        const oidDef = this.huawei_oidDB.SrvFlowTable();
        let oids: Oid[] = [];
        let index = 0;
        if(this.lastSrvPortId[oltid] >= 0) {
            this.lastSrvPortId[oltid]++;
            index = this.lastSrvPortId[oltid];
        }
        else {
            index = parseInt('FFFFFFFF', 16);
        }
        
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowRowStatus', snmp.ObjectType.Integer32, RowStatus['createAndGo'], index));
        //Frame 
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowPara1', snmp.ObjectType.Integer32, ontParams.frame, index));
        // Slot
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowPara2', snmp.ObjectType.Integer32, ontParams.slot, index));
        // Port
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowPara3', snmp.ObjectType.Integer32, ontParams.port, index));
        // Ont or GEM port id
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowPara4', snmp.ObjectType.Integer32, ontParams.ontId, index));
        // GEM or ETH port
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowPara5', snmp.ObjectType.Integer32, 1, index));
        // gpon(4) or end2end(14) mode
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowParaType', snmp.ObjectType.Integer32, 14, index));
        // vlan id
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowVlanid', snmp.ObjectType.Integer32, 42, index));
        // User vlan type
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowMultiServiceType', snmp.ObjectType.Integer32, 1, index));
        // User vlan id
        oids.push(this.huawei_oidDB.getFullOid(oidDef, 'hwExtSrvFlowMultiServiceUserPara', snmp.ObjectType.Integer32, 65535, index));
       
        console.log(oids);
        
        // return this.snmpService.set(oltid, oids);

    }

    getServicePorts(oltid: number, ontParams: OntParams = null) {   // Fast response after init
        if(ontParams !== null) {
            if(typeof this.ServicePorts !== 'undefined') {
                if(typeof this.ServicePorts[ontParams.frame] !== 'undefined' ) {
                    if(typeof this.ServicePorts[ontParams.frame][ontParams.slot] !== 'undefined') {
                        if(typeof this.ServicePorts[ontParams.frame][ontParams.slot][ontParams.port][ontParams.ontId] !== 'undefined') {
                            return this.ServicePorts[ontParams.frame][ontParams.slot][ontParams.port][ontParams.ontId];
                        }
                    }
                }
            }
        } else {
            return this.ServicePorts;
        }
        return null;
    }

    getIpTrafficParamTable() {
        return this.IpTrafficParamTable;
    }

    private async initIpTrafficParamTable(oltid: any){
        const oids = this.huawei_oidDB.HwIpTrafficParamTable()
        const numericOids = this.oidDB.getChildrenOids(oids);
        const names = this.oidDB.getChildrenNames(oids);

        let snmpOids: Oid[] = [];
        snmpOids = await this.snmpService.subtree(oltid, numericOids[0]); // hwIpTrafficNames
        
        snmpOids.forEach((oid) => {
            this.IpTrafficParamTable[oid.oid.split('.').pop()] = {
                [names[0]]: Buffer.from(oid.value).toString()
            };
        });
    }

    async initServicePorts(oltid: number): Promise<number> {
        Logger.log('Service port list init started for OLT ' + oltid, 'ServicePortService');
        this.initIpTrafficParamTable(oltid);

        this.ServicePorts = {};
        this.lastSrvPortId[oltid] = 0;

        const snmpTable = await this.snmpService.table(oltid, this.oids.base);
        
        for (let spId in snmpTable) {
            const data = snmpTable[spId];
            let srvPort: ServicePort;
            const params = this.calcKeysFromParas(data);

            if(typeof this.ServicePorts[params.frame] === 'undefined') {
                this.ServicePorts[params.frame] = {};
            }
            if(typeof this.ServicePorts[params.frame][params.slot] === 'undefined') {
                this.ServicePorts[params.frame][params.slot] = {};
            }
            if(typeof this.ServicePorts[params.frame][params.slot][params.port] === 'undefined') {
                this.ServicePorts[params.frame][params.slot][params.port] = {};
            }
            if(typeof this.ServicePorts[params.frame][params.slot][params.port][params.ontId] === 'undefined') {
                this.ServicePorts[params.frame][params.slot][params.port][params.ontId] = [];
            } 

            if(Number(spId) > this.lastSrvPortId[oltid]) {
                this.lastSrvPortId[oltid] = Number(spId);  // Update last id
            }

            const para4lsb = data['5'] % 2; // hwExtSrvFlowPara4
            const paraType = data['7'];     // hwExtSrvFlowParaType    
            
            srvPort = {
                id: Number(spId),
                portIndex: data['6'],
                vlanId: data['8'],
                receiveTrafficIndex: data['9'],
                transmitTrafficIndex: data['10'],
                tagTransform: data['18']
            }

            if(para4lsb == 1) {
                srvPort.portType = srvPortType['Iphost'];
            } else {
                if(paraType == srvPortParaType['Gpon']) {
                    srvPort.portType = srvPortType['Gemport'];
                } else {
                    if(paraType == srvPortParaType['Port']) {
                        srvPort.portType = srvPortType['Eth'];
                    } else {
                        srvPort.portType = srvPortType['Undefined'];
                        Logger.error('srvPortType is Undefined!');
                    }
                }
            }
            this.ServicePorts[params.frame][params.slot][params.port][params.ontId].push(srvPort);
        }
        Logger.log('Service port list initialized for OLT ' + oltid + ': ' + Object.keys(snmpTable).length + ' service port(s) found', 'ServicePortService');
        return this.lastSrvPortId[oltid];
    }

    async deleteServicePort(params) {
        const id = this.ServicePorts[params.frame][params.slot][params.port][params.ontId][params.i].id;
        const oid:Oid = {
            oid: this.numericOids[13] + '.' + id,   // hwExtSrvFlowRowStatus mib
            value: RowStatus['destroy'],
            type: snmp.ObjectType.Integer
        }
        
        const snmpResp = await this.snmpService.set(params.oltid, [oid]).catch((error) => {
            throw new NotFoundException(error.toString());
        });
        this.ServicePorts[params.frame][params.slot][params.port][params.ontId].splice(params.i);
        
        return snmpResp;
    }
}